/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CancelBookingRequestModel } from '../../models/cancel-booking-request-model';

export interface ApiMedicalAdvisorCancelBookingPost$Params {
      body?: CancelBookingRequestModel
}

export function apiMedicalAdvisorCancelBookingPost(http: HttpClient, rootUrl: string, params?: ApiMedicalAdvisorCancelBookingPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiMedicalAdvisorCancelBookingPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BookingStrictHttpResponse<void>;
    })
  );
}

apiMedicalAdvisorCancelBookingPost.PATH = '/api/MedicalAdvisor/CancelBooking';
